import React from "react";

export default class StringArrayRenderer extends React.Component<any>
{
    render(): React.ReactNode 
{
        const array = this.props.value as string[];

        return <b>
            {
                array.length > 0
                    ?
                    array.join(", ")
                    :
                    <div>-</div>
            }
        </b>;
    }
}